import { date_fetch_formatter } from "./date-format-utils";
import { getCookie } from "./cookies";

const putWaitEntry = async (entry) => {
	let token = btoa(encodeURI(getCookie('lola-sesh')));
	return await fetch("https://fm6wivz7qcpe3batatlu627iri0lmnbw.lambda-url.us-east-1.on.aws/",
		{
			method: "post",
			body: JSON.stringify(entry),
			mode: "cors",
			credentials: "include",
			headers: {
				"authorization": `Bearer ${token}`,
				"lola-action": "put-wait",
				"content-type": "text/plain",
			}
		})
		.then((r) => r.json())
		.then(async (json) => {
			if (getCookie('bruce-mode') === "true") {
				return await new Promise((resolve) =>
					setTimeout(() => resolve({ ok: true, data: json }), Math.random() * 750 + 1500)
				)
			} else {
				return {
					ok: true,
					data: json
				};
			}
		})
		.catch(async (err) => {
			console.log(err)
			if (getCookie('bruce-mode') === "true") {
				return await new Promise((resolve) =>
					setTimeout(() => resolve({ ok: false, data: err }), Math.random() * 750 + 1500)
				)
			} else {
				return {
					ok: false,
					data: err
				};
			}
		});
}

const getTodaysWaitList = async (date) => {
	let formattedDate = date_fetch_formatter(date);
	let token = btoa(encodeURI(getCookie('lola-sesh')));
	return await fetch("https://fm6wivz7qcpe3batatlu627iri0lmnbw.lambda-url.us-east-1.on.aws/",
		{
			method: "get",
			mode: "cors",
			credentials: "include",
			headers: {
				"authorization": `Bearer ${token}`,
				"lola-action": "get-wait",
				"reservation-date": formattedDate,
				"content-type": "text/plain",
			}
		})
		.then((r) => {
			// // @ts-ignore
			// let reader: ReadableStreamDefaultReader<object> = r.body.getReader();
			// while (true) {
			// 	let res = await reader.read();
			// 	if (res.done) {
			// 		break;
			// 	} else {
			// 		// @ts-ignore
			// 		console.log(new TextDecoder("utf-8").decode(res.value));
			// 	}
			// }

			return r.json();
		})
		.then(async (json) => {
			if (getCookie('bruce-mode') === "true") {
				return await new Promise((resolve) =>
					setTimeout(() => resolve({ ok: true, data: json }), Math.random() * 750 + 1500)
				)
			} else {
				return {
					ok: true,
					data: json
				};
			}
		})
		.catch(async (err) => {
			console.log(err)
			if (getCookie('bruce-mode') === "true") {
				return await new Promise((resolve) =>
					setTimeout(() => resolve({ ok: false, data: err }), Math.random() * 750 + 1500)
				)
			} else {
				return {
					ok: false,
					data: err
				};
			}
		});
};

const verifyToken = async () => {
	let token = btoa(encodeURI(getCookie('lola-sesh')));
	return await fetch("https://fm6wivz7qcpe3batatlu627iri0lmnbw.lambda-url.us-east-1.on.aws/",
		{
			method: "get",
			mode: "cors",
			credentials: "include",
			headers: {
				"authorization": `Bearer ${token}`,
				"lola-action": "authorize",
				"content-type": "text/plain",
			}
		})
		.then((r) => {
			return r.json();
		})
		.then(async (json) => {
			if (getCookie('bruce-mode') === "true") {
				return await new Promise((resolve) =>
					setTimeout(() => resolve({ ok: true, data: json }), Math.random() * 750 + 1500)
				)
			} else {
				return {
					ok: true,
					data: json
				};
			}
		})
		.catch(async (err) => {
			console.log(err)
			if (getCookie('bruce-mode') === "true") {
				return await new Promise((resolve) =>
					setTimeout(() => resolve({ ok: false, data: err }), Math.random() * 750 + 1500)
				)
			} else {
				return {
					ok: false,
					data: err
				};
			}
		});
}

const login = async (encoded) => {
	// get the screen resolution BITCH

	const screenWidth = window.screen.width;
	const screenHeight = window.screen.height;
	const pixelRatio = window.devicePixelRatio;
	const canvas = document.createElement("canvas");
	const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
	let GL_Data = false;
	if (gl) {
		const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
		GL_Data = {
			renderer: debugInfo['UNMASKED_RENDERER_WEBGL'],
			vendor: debugInfo['UNMASKED_VENDOR_WEBGL'],
		}
	}
	
	return await fetch("https://fm6wivz7qcpe3batatlu627iri0lmnbw.lambda-url.us-east-1.on.aws/",
		{
			method: "post",
			mode: "cors",
			credentials: "include",
			headers: {
				"authorization": `Bearer ${encoded}`,
				"lola-action": "login",
				"content-type": "text/plain",
				"device-data": JSON.stringify({
					screenWidth,
					screenHeight,
					pixelRatio,
					GL_Data: GL_Data
				})
			}
		})
		.then(async (r) => {
			return r.json();
		})
		.then(async (res) => {
			if (res.body.success) {
				let now = new Date();
				now.setDate(now.getDate() + 1);
				document.cookie = `lola-sesh=${res.body['token']};expires=${now.toUTCString()};secure;samesite=lax`;
			} else {
				console.log("here");
				document.cookie = "lola-sesh=null";
			}
			// return res;
			if (getCookie('bruce-mode') === "true") {
				return await new Promise((resolve) =>
					setTimeout(() => resolve(res), Math.random() * 750 + 1500)
				)
			} else {
				return res
			}
		})
		.catch(async (err) => {
			console.log(err)
			if (getCookie('bruce-mode') === "true") {
                return await new Promise((resolve) =>
                    setTimeout(() => resolve(err), Math.random() * 750 + 1500)
                )
            } else {
				return err;
            }
		});
}

const deleteWaitEntry = async (id) => {
	let token = btoa(encodeURI(getCookie('lola-sesh')));
	return await fetch("https://fm6wivz7qcpe3batatlu627iri0lmnbw.lambda-url.us-east-1.on.aws/",
		{
			method: "delete",
			mode: "cors",
			credentials: "include",
			headers: {
				"authorization": `Bearer ${token}`,
				"lola-action": "delete-wait",
				"wait-id": id,
				"content-type": "text/plain",
			}
		})
		.then(async (r) => {
			// // @ts-ignore
			// let reader: ReadableStreamDefaultReader<object> = r.body.getReader();
			// while (true) {
			// 	let res = await reader.read();
			// 	if (res.done) {
			// 		break;
			// 	} else {
			// 		// @ts-ignore
			// 		console.log(new TextDecoder("utf-8").decode(res.value));
			// 	}
			// }

			return r.json();
		})
		.then(async (json) => {
            if (getCookie('bruce-mode') === "true") {
                return await new Promise((resolve) =>
                    setTimeout(() => resolve({ ok: true, data: json }), Math.random() * 750 + 1500)
                )
            } else {
                return {
                    ok: true,
                    data: json
                };
            }
		})
		.catch(async (err) => {
			console.log(err)
            if (getCookie('bruce-mode') === "true") {
                return await new Promise((resolve) =>
                    setTimeout(() => resolve({ ok: false, data: err }), Math.random() * 750 + 1500)
                )
            } else {
                return {
                    ok: false,
                    data: err
                };
            }
		});
};

export {
	putWaitEntry,
	getTodaysWaitList,
	deleteWaitEntry,
	login,
	verifyToken,
}
